// extracted by mini-css-extract-plugin
export default {"displayContainer":"RequestDisplay_displayContainer__lJv3E","copyIcon":"RequestDisplay_copyIcon__Sqvxa"};